module.exports = __webpack_public_path__ + "img/cant_add_banner.e9d82c75.png";